export default "__VITE_ASSET__fQ98bsDx__"